// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SleepSchoolMindfulness = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx={40} cy={40} r={40} fill="#FFAD42" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M39.103 63.7c-.735 0-1.048-.272-1.239-.437-1.314-1.138-1.635-3.59-1.945-5.962-.118-.901-.288-2.203-.491-2.759-.814-.024-1.644.051-2.516.13-1.38.124-2.806.25-4.285-.007A4.909 4.909 0 0 1 25.58 53.4c-1.081-.905-1.724-3.315-2.287-8.558l-.017-.16c-.154-.072-.344-.138-.53-.204-.791-.279-2.438-.858-2.228-2.974a1.38 1.38 0 0 1 .019-.123c.209-1.013 1.02-2.008 1.881-3.062.502-.616 1.438-1.763 1.45-2.166-.04-1.43.041-7.34.044-7.592 0-7.598 7.132-10.593 7.678-10.81 5.793-2.493 19.633-3.257 25.564 10.266 5.276 12.03-2.41 20.654-4.625 22.8l.113.475c.584 2.467.971 4.097-.483 5.18-8.08 6.012-11.505 7.227-13.056 7.227Z"
			fill="#000"
		/>
	</svg>
);
export default SleepSchoolMindfulness;
